import React, {Component, useRef} from 'react'
import {compose} from 'redux'
import flattenDeep from 'lodash/flattenDeep'
import Analytics from '..'
import {formStepsSubmit} from '../events'
import {SnowplowReactContext} from '../SnowplowContextManager'

const withSnowplow = WrappedComponent =>
  class extends Component {
    static displayName = `${WrappedComponent.displayName}WithSnowplow`
    static contextType = SnowplowReactContext

    /**
     * Parse sync errors from Redux
     *
     * @param {object} - An object with syncErrors from Redux, like:
     * {
        borrower: {
          name: 'Required',
          surname: 'Required',
        },
        email: 'Wrong email',
      }
     * @returns {array} - An array with errors like:
     * [['borrower.name ::: Required', 'borrower.surname ::: Required'], 'email ::: Wrong email']
     */
    parseSyncErrorsWorker = (e, path = '') =>
      Object.entries(e).reduce((acc, [k, v]) => {
        const newPath = path ? `${path}.${k}` : k

        if (typeof v === 'object') {
          return [...acc, this.parseSyncErrorsWorker(v, newPath)]
        }

        return [...acc, `${newPath} ::: ${v}`]
      }, [])

    /**
     * Parse sync errors
     *
     * @param {array} - A formatter array of arrays from parseSyncErrorsWorker function
     * @returns {array} - An array with errors after flattening from the lodash package, like
     * ['borrower.name ::: Required', 'borrower.surname ::: Required', 'email ::: Wrong email']
     */
    parseSyncErrors = (e, path) =>
      compose(
        flattenDeep,
        this.parseSyncErrorsWorker
      )(e, path)

    onSubmitClickAnalytic = analyticsContexts => (
      event,
      additionalEventData,
      text = 'Save & Continue',
      syncErrors = null
    ) => {
      const analytics = new Analytics(
          formStepsSubmit.analytics({text}, analyticsContexts)
        ),
        invalidFields = syncErrors && this.parseSyncErrors(syncErrors)

      analytics.event({text: '', invalidFields})
    }

    onSubmitSnowplowEvent = (text = 'Save & Continue') => {
      const {formData: {syncErrors}} = this.props,
        analytics = new Analytics(
          formStepsSubmit.analytics({text}, this.context)
        ),
        invalidFields = syncErrors && this.parseSyncErrors(syncErrors)

      analytics.event({text: '', invalidFields})
    }

    render() {
      const {...props} = this.props

      return (
        <WrappedComponent
          {...props}
          onSubmitClickAnalytic={this.onSubmitClickAnalytic}
          onSubmitSnowplowEvent={this.onSubmitSnowplowEvent}
        />
      )
    }
  }

export default withSnowplow
